import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import { AdminUserReq } from './users.slice';
import { addAuth } from './auth.slice';
import { Cookies } from 'react-cookie';
import axios from 'axios';

const initialState = {
    data: {},
    trip: {},
    trips: [],
    admin: {},
    admins: [],
    sidebar: true,
    error: null,
    loading: false,
    mloading: false,
}

export const AdminProfileUpdateReq = createAsyncThunk('AdminProfileUpdateReq', async ({ data, id }, { rejectWithValue, dispatch }) => {
    try {
        const cookies = new Cookies()
        const response = await axios.put(`${BASEURL}/partner/update/profile/${id}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${cookies.get('auth')}`,
                }
            })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(addAuth(res?.data?.data))
                    dispatch(toastSuccess(res?.data?.message))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminForgotPassReq = createAsyncThunk('AdminForgotPassReq', async ({ data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/send/forgot-password/link`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminResetPassReq = createAsyncThunk('AdminResetPassReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/reset-password`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    navigate('/login')
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})


export const AdminListReq = createAsyncThunk('AdminListReq', async ({ text, data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/list?text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})
export const AdminSearchReq = createAsyncThunk('AdminSearchReq', async ({ text, data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/list?text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const SingleAdminReq = createAsyncThunk('SingleAdminReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/admin/info/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})
export const updateAdminReq = createAsyncThunk('updateAdminReq', async ({ id, data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const cookies = new Cookies()
        const response = await axios.put(`${BASEURL}/admin/admin/update/${id}`,
            data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${cookies.get('auth')}`,
            }
        })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    navigate('/admin/admin-list');
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const deleteAdminReq = createAsyncThunk('deleteAdminReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/admin/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(AdminListReq({}))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})
export const banUserReq = createAsyncThunk('banUserReq', async ({ id, key, page, data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/partner/user/ban/${id}`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    dispatch(AdminUserReq({ role: key, page: page ? page : 1, }))
                }
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const DriverTripsReq = createAsyncThunk('DriverTripsReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/driver/rides`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const tripInfoReq = createAsyncThunk('tripInfoReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/driver/ride/info/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminSlice = createSlice({
    name: 'adminSlice',
    initialState: initialState,
    reducers: {
        isSide: (state, action) => {
            state.sidebar = action.payload
            return state
        },
    },
    extraReducers: (builder) => {
        builder.addCase(AdminForgotPassReq.pending, (state, action) => {
            state.mloading = true
            return state
        })
        builder.addCase(AdminForgotPassReq.fulfilled, (state, action) => {
            state.mloading = false
            return state
        })
        builder.addCase(AdminForgotPassReq.rejected, (state, action) => {
            state.mloading = false
            state.error = 'Error occured'
        })
        builder.addCase(AdminResetPassReq.pending, (state, action) => {
            state.mloading = true
            return state
        })
        builder.addCase(AdminResetPassReq.fulfilled, (state, action) => {
            state.mloading = false
            return state
        })
        builder.addCase(AdminResetPassReq.rejected, (state, action) => {
            state.mloading = false
            state.error = 'Error occured'
        })
        builder.addCase(AdminProfileUpdateReq.pending, (state, action) => {
            state.mloading = true
            state.data = {}
            return state
        })
        builder.addCase(AdminProfileUpdateReq.fulfilled, (state, action) => {
            state.mloading = false
            state.data = action.payload.data
            return state
        })
        builder.addCase(AdminProfileUpdateReq.rejected, (state, action) => {
            state.mloading = false
            state.data = {}
            state.error = 'Error occured'
        })
        builder.addCase(AdminListReq.pending, (state, action) => {
            state.loading = true
            state.admins = []
            return state
        })
        builder.addCase(AdminListReq.fulfilled, (state, action) => {
            state.loading = false
            state.admins = action.payload.data
            return state
        })
        builder.addCase(AdminListReq.rejected, (state, action) => {
            state.loading = false
            state.admins = []
            state.error = 'Error occured'
        })
        builder.addCase(AdminSearchReq.pending, (state, action) => {
            state.admins = []
            return state
        })
        builder.addCase(AdminSearchReq.fulfilled, (state, action) => {
            state.admins = action.payload.data
            return state
        })
        builder.addCase(AdminSearchReq.rejected, (state, action) => {
            state.admins = []
            state.error = 'Error occured'
        })
        builder.addCase(SingleAdminReq.pending, (state, action) => {
            state.mloading = true
            state.admin = {}
            return state
        })
        builder.addCase(SingleAdminReq.fulfilled, (state, action) => {
            state.mloading = false
            state.admin = action.payload.data
            return state
        })
        builder.addCase(SingleAdminReq.rejected, (state, action) => {
            state.mloading = false
            state.admin = {}
            state.error = 'Error occured'
        })
        builder.addCase(DriverTripsReq.pending, (state, action) => {
            state.mloading = true
            state.trips = []
            return state
        })
        builder.addCase(DriverTripsReq.fulfilled, (state, action) => {
            state.mloading = false
            state.trips = action.payload.data
            return state
        })
        builder.addCase(DriverTripsReq.rejected, (state, action) => {
            state.mloading = false
            state.trips = []
            state.error = 'Error occured'
        })
        builder.addCase(tripInfoReq.pending, (state, action) => {
            state.loading = true
            state.trip = {}
            return state
        })
        builder.addCase(tripInfoReq.fulfilled, (state, action) => {
            state.loading = false
            state.trip = action.payload.data
            return state
        })
        builder.addCase(tripInfoReq.rejected, (state, action) => {
            state.loading = false
            state.trips = {}
            state.error = 'Error occured'
        })
        builder.addCase(updateAdminReq.pending, (state, action) => {
            state.mloading = true
            return state
        })
        builder.addCase(updateAdminReq.fulfilled, (state, action) => {
            state.mloading = false
            return state
        })
        builder.addCase(updateAdminReq.rejected, (state, action) => {
            state.mloading = false
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export const { isSide } = AdminSlice.actions
export default AdminSlice.reducer